import { useIsMobileDevice } from "hooks";
import { useTranslation } from "react-i18next"
import UnberryModal from "../UnberryModal";
import Carousel, { CarouselItem } from "../Carousel";
import './style.scss';
import CameraPermissionTabImageTwo from '../../../assets/img/permission/cam-permission-tab-image-2.png';
import CameraPermissionTabImageThird from '../../../assets/img/permission/cam-permission-tab-image-3.png';
import CameraPermissionCarouselOne from '../../../assets/img/permission/cam-permission-carousel-1.png';
import CameraPermissionCarouselTwo from '../../../assets/img/permission/cam-permission-carousel-2.png';
import CameraPermissionCarouselThree from '../../../assets/img/permission/cam-permission-carousel-3.png';
import CamMicPermissionTabImageOne from '../../../assets/img/permission/cam-mic-permission-tab-image-1.png';
import CamMicPermissionTabImageTwo from '../../../assets/img/permission/cam-mic-permission-tab-image-2.png';
import CamMicPermissionTabImageThird from '../../../assets/img/permission/cam-mic-permission-tab-image-3.png';
import CamMicPermissionCarouselOne from '../../../assets/img/permission/cam-mic-permission-carousel-1.jpg';
import CamMicPermissionCarouselTwo from '../../../assets/img/permission/cam-mic-permission-carousel-2.jpg';
import CamMicPermissionCarouselThree from '../../../assets/img/permission/cam-mic-permission-carousel-3.jpg';
import IOSCamMicPermissionCarouselThree from '../../../assets/img/permission/ios-cam-mic-permission-carousel-3.jpg';
import AndroidCamPermissionCarouselThree from '../../../assets/img/permission/android-cam-permission-carousel-3.jpg';

import { PERMISSION_ERRORS } from "constants/globalConstants";

const { NO_DEVICE, NO_INTERNET, VIDEO_SOURCE, PERMISSION_DENIED, PERMISSION_DENIED_BY_SYSTEM, CAMERA_FEED, API_FAILURE } = PERMISSION_ERRORS;

const isUserAgentIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent)

const cameraTabData = (t) => ([
  {
    tabText: "camTab.step1.tab",
    imgSrc: CamMicPermissionTabImageOne,
    carouselText: isUserAgentIOS()
      ? "camTab.step1.carousel_ios"
      : "camTab.step1.carousel_others",
    carouselImgSrc: isUserAgentIOS()
      ? CameraPermissionCarouselOne
      : CamMicPermissionCarouselOne
  },
  {
    tabText: "camTab.step2.tab",
    imgSrc: CameraPermissionTabImageTwo,
    carouselText: isUserAgentIOS()
      ? "camTab.step2.carousel_ios"
      : "camTab.step2.carousel_others",
    carouselImgSrc: isUserAgentIOS()
      ? CameraPermissionCarouselTwo
      : CamMicPermissionCarouselTwo
  },
  {
    tabText: "camTab.step3.tab",
    imgSrc: CameraPermissionTabImageThird,
    carouselText: isUserAgentIOS()
      ? "camTab.step3.carousel_ios"
      : "camTab.step3.carousel_ios",
    carouselImgSrc: isUserAgentIOS()
      ? CameraPermissionCarouselThree
      : AndroidCamPermissionCarouselThree
  }
]);

const camMicTabData = (t) => ([
  {
    tabText: "camMicTab.step1.tab",
    imgSrc: CamMicPermissionTabImageOne,
    carouselText: isUserAgentIOS()
      ? "camMicTab.step1.carousel_ios"
      : "camTab.step1.carousel_others",
    carouselImgSrc: isUserAgentIOS()
      ? CameraPermissionCarouselOne
      : CamMicPermissionCarouselOne
  },
  {
    tabText: "camMicTab.step2.tab",
    imgSrc: CamMicPermissionTabImageTwo,
    carouselText: isUserAgentIOS()
      ? "camMicTab.step2.carousel_ios"
      : "camMicTab.step2.carousel_others",
    carouselImgSrc: isUserAgentIOS()
      ? CameraPermissionCarouselTwo
      : CamMicPermissionCarouselTwo
  },
  {
    tabText: "camMicTab.step3.tab",
    imgSrc: CamMicPermissionTabImageThird,
    carouselText: isUserAgentIOS()
      ? "camMicTab.step3.carousel_ios"
      : "camMicTab.step3.carousel_others",
    carouselImgSrc: isUserAgentIOS()
      ? IOSCamMicPermissionCarouselThree
      : CamMicPermissionCarouselThree
  }
]);

const CarouselComponent = ({ type = "camera" }) => {
  const { t } = useTranslation()
  const tabData = type === "camera" ? cameraTabData(t) : camMicTabData(t)

  return (
    <Carousel>
      {
        tabData.map((tab, index) => {
          return (
            <CarouselItem>
              <div className={`tab flex flex-col items-center justify-center`}>
                <div className="tab-description flex items-center justify-center mb-20">
                  <div className="tab-number-carousel">
                    <span>{index + 1}</span>
                  </div>
                  <p className="tab-text-carousel">{t(`permissions.${tab.carouselText}`)}</p>
                </div>
                <div className="tab-image-carousel flex items-center justify-center">
                  <img src={tab.carouselImgSrc} alt="permission-access-microphone" />
                </div>
              </div>
            </CarouselItem>
          )
        })
      }
    </Carousel>
  );
};

const PermissionTabComponent = ({ tabText, tabNumber, imgSrc }) => {

  return (
    <div className={`tab pl-20 pr-20
      flex flex-col items-center justify-start
        ${tabNumber === 2 ? 'border' : ''}
      `}>
      <div className="tab-description flex items-center justify-center mb-20">
        <div className="tab-number">
          <span>{tabNumber}</span>
        </div>
        <p className="tab-text">{tabText}</p>
      </div>
      <div className="tab-image">
        <img src={imgSrc} alt="permission-access-microphone-1" />
      </div>
    </div>
  )
};

const PermissionsModal = ({ visible = false, type = "", device = "camera" }) => {
  const isMobile = useIsMobileDevice();
  const { t } = useTranslation()
  const tabData = device === "camera" ? cameraTabData(t) : camMicTabData(t);
  const noCarouselType = [NO_INTERNET, VIDEO_SOURCE, NO_DEVICE, PERMISSION_DENIED_BY_SYSTEM, CAMERA_FEED, API_FAILURE].includes(type);
  const modalWidth = isMobile ? "80%" : noCarouselType ? "50%" : "80%";

  return (
    <UnberryModal
      visible={visible}
      footer={false}
      className={"permission-modal"}
      width={modalWidth}
      closable={false}
      keyboard={false}
      maskStyle={{
        backdropFilter: "blur(4px)"
      }}
    >
      <div className={`permission-modal-body ${isMobile ? "mt-40" : ""} mb-40`}>
        <div className="description flex flex-col items-center justify-center mb-40">
          <h1 className={`${isMobile ? "heading-mobile size-28" : "size-40"}`}>
            {
              type === NO_INTERNET
                ? t("permissions.no_internet.title")
                : type === CAMERA_FEED
                  ? t("permissions.cam_feed.title")
                  : type === VIDEO_SOURCE
                    ? t("permissions.video_source.title")
                    : type === NO_DEVICE
                      ? t("permissions.no_device.title", { device: device[0]?.toUpperCase() + device?.slice(1,) })
                      : (type === PERMISSION_DENIED || type === PERMISSION_DENIED_BY_SYSTEM)
                        ? t("permissions.permission_denied.title", { device })
                        : type === API_FAILURE
                          ? ""
                          : t("permissions.permission_general.title", { device })
            }
          </h1>
          <p className={`${isMobile ? "heading-text size-14" : "size-16"}`}>
            {
              type === NO_INTERNET
                ? t("permissions.no_internet.subtext")
                : type === CAMERA_FEED
                  ? t("permissions.cam_feed.subtext")
                  : type === VIDEO_SOURCE
                    ? t("permissions.video_source.subtext")
                    : type === NO_DEVICE
                      ? t("permissions.no_device.subtext", { device })
                      : type === PERMISSION_DENIED
                        ? t("permissions.permission_denied.subtext", { device })
                        : type === PERMISSION_DENIED_BY_SYSTEM
                          ? t("permissions.permission_denied_by_system.subtext", { device })
                          : type === API_FAILURE
                            ? t("permissions.api_failure.subtext")
                            : type
            }
          </p>
        </div>
        {
          !noCarouselType
            ? <div className="permission-tabs">
              {
                isMobile ? <CarouselComponent type={type} /> :
                  tabData.map((tab, index) => {
                    return (
                      <PermissionTabComponent
                        tabText={t(`permissions.${tab.tabText}`)}
                        tabNumber={index + 1}
                        imgSrc={tab.imgSrc}
                      />
                    )
                  })
              }
            </div> : <></>
        }
      </div>
    </UnberryModal>
  )
};

export default PermissionsModal;